@if (currentMsisdn()) {
  <div
    class="text-white bg-black p-6 desktop:p-4 flex justify-between items-center rounded desktop:rounded-t cursor-pointer relative z-10"
    (click)="isOpen.set(!isOpen())"
  >
    <div>
      <div
        class="text-mobileH3 tablet:text-tabletH3 desktop:text-desktopH3 font-headline"
        scClickToCopy="{{ currentMsisdn().msisdn }}"
      >
        {{
          currentMsisdn().isTerminated
            ? currentMsisdn().isJottaInUse
              ? ('shared.letsGoCloud' | scTranslate | async)
              : ('shared.terminated' | scTranslate | async)
            : (currentMsisdn().msisdn | scMsisdn | scTranslate | async | scPhoneNumber)
        }}
      </div>
      <div class="text-mobileMd tablet:text-tabletMd desktop:text-desktopMd font-light">
        @if (!currentMsisdn().isTerminated) {
          {{ currentMsisdn().description }}
        }
      </div>
    </div>
    <sc-svg
      name="arrow-down"
      size="h-6 w-6"
      class="transform"
      [class.rotate-180]="isOpen()"
    ></sc-svg>
  </div>
  @if (isOpen()) {
    <div class="bg-white border rounded border-black">
      <div class="px-3 pt-3">
        <sc-msisdn-radio-button-list></sc-msisdn-radio-button-list>
      </div>
      <div class="p-3">
        <!--        <sc-button-->
        <!--          relativeUrl ="subscription/add-subscription"-->
        <!--          variant="alternate"-->
        <!--          class="h-10 flex items-center"-->
        <!--        >-->
        <!--           <span>{{ 'shared.addSim' | scTranslate | async }}</span>-->
        <!--           <sc-svg name="plus"></sc-svg>-->
        <!--         </sc-button>-->
      </div>
    </div>
  }
}
@if (!currentMsisdn()) {
  <div
    class="text-white bg-black p-6 desktop:p-4 flex justify-between items-center rounded desktop:rounded-t cursor-pointer relative z-10 min-h-24"
  ></div>
}
